import React, { createContext, useContext, useReducer, useEffect } from "react";
import { generateMockTransactions } from "../data/mockData";

const AppContext = createContext();

const initialState = {
  transactions: [],
  theme: "dark",
  role: "admin",
  filters: { search: "", category: "all", type: "all", sortBy: "date", sortOrder: "desc" },
  activePage: "dashboard",
};

function reducer(state, action) {
  switch (action.type) {
    case "SET_TRANSACTIONS": return { ...state, transactions: action.payload };
    case "ADD_TRANSACTION": {
      const updated = [action.payload, ...state.transactions];
      localStorage.setItem("fd_transactions", JSON.stringify(updated));
      return { ...state, transactions: updated };
    }
    case "EDIT_TRANSACTION": {
      const updated = state.transactions.map((t) => (t.id === action.payload.id ? action.payload : t));
      localStorage.setItem("fd_transactions", JSON.stringify(updated));
      return { ...state, transactions: updated };
    }
    case "DELETE_TRANSACTION": {
      const updated = state.transactions.filter((t) => t.id !== action.payload);
      localStorage.setItem("fd_transactions", JSON.stringify(updated));
      return { ...state, transactions: updated };
    }
    case "TOGGLE_THEME": {
      const theme = state.theme === "dark" ? "light" : "dark";
      localStorage.setItem("fd_theme", theme);
      return { ...state, theme };
    }
    case "SET_ROLE": {
      localStorage.setItem("fd_role", action.payload);
      return { ...state, role: action.payload };
    }
    case "SET_FILTER": return { ...state, filters: { ...state.filters, ...action.payload } };
    case "SET_PAGE": return { ...state, activePage: action.payload };
    default: return state;
  }
}

export function AppProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const savedTheme = localStorage.getItem("fd_theme") || "dark";
    const savedRole = localStorage.getItem("fd_role") || "admin";
    const savedTx = localStorage.getItem("fd_transactions");
    const transactions = savedTx ? JSON.parse(savedTx) : generateMockTransactions();
    if (!savedTx) localStorage.setItem("fd_transactions", JSON.stringify(transactions));
    dispatch({ type: "SET_TRANSACTIONS", payload: transactions });
    if (savedTheme !== "dark") dispatch({ type: "TOGGLE_THEME" });
    if (savedRole !== "admin") dispatch({ type: "SET_ROLE", payload: savedRole });
  }, []);

  return <AppContext.Provider value={{ state, dispatch }}>{children}</AppContext.Provider>;
}

export function useApp() {
  return useContext(AppContext);
}
